var r=function(r,u){void 0===u&&(u=!1);for(var h=!1,n="",o=[],p="",t=0;t<r.length;t++)"{"===r[t]&&"{"===r[t+1]?(h=!0,o.push(p),p=""):"}"===r[t]&&"}"===r[t-1]?(o.push(p),p="",h=!1):(h||(n+=r[t]),p+=r[t]);return o.push(p),u?o:n};export{r as parseString};
//# sourceMappingURL=utils.js.map
